import { WorkPlace } from '@/DTOS/WorkPlace/WorkPlace';
import { Divider, Drawer, List, Tag } from 'antd';
import { FC } from 'react';
import '../WorkPlaceDrawer/WorkPlaceDrawer.css';

interface WorkPlaceDrawerProps {
  modalInformation: boolean;
  handleModalInformationClose: () => void;
  selectedRecord: WorkPlace | null;
}

const WorkPlaceDrawer: FC<WorkPlaceDrawerProps> = ({
  modalInformation,
  handleModalInformationClose,
  selectedRecord,
}) => {
  return (
    <Drawer
      title={`Informatii suplimentare`}
      placement={'right'}
      onClose={handleModalInformationClose}
      open={modalInformation} // Corrected 'open' to 'visible'
      width={600}
      key={'drawer_right'}
    >
      <h2>Descriere</h2>
      <p className='font-size-16'>
        <span className='font-werght-bold'>Denumire:</span> {selectedRecord?.name}
      </p>
      <p className='font-size-16'>
        <span className='font-werght-bold'>Adresa:</span> {selectedRecord?.country}, Jud. {selectedRecord?.locality},{' '}
        {selectedRecord?.address}
      </p>
      <p className='font-size-16'>
        <span className='font-werght-bold'>Detalii:</span> {selectedRecord?.details}
      </p>

      <Divider />

      <h2>Orar</h2>
      <List.Item className='timetable-list'>
        <Tag color='blue' className='timetable-tag'>
          <div className='timetable-container'>{selectedRecord?.timetable}</div>
        </Tag>
      </List.Item>

      <Divider />

      <h2>Agenti</h2>
      <List.Item className='agent-list'>
        {selectedRecord?.contactPersons?.map((item, index) => (
          <Tag color='blue' className='agent-tag' key={index}>
            <div className='agent-container'>
              <span className='font-weight-bold'>{item?.name}</span>
              <span className='agent-role-email-phone'>
                {item?.role} - {item?.email} - {item?.phone} -{' '}
                <span className='font-weight-bold'>{item?.isActive ? 'Activ' : 'Inactiv'}</span>
              </span>
            </div>
          </Tag>
        ))}
      </List.Item>
    </Drawer>
  );
};

export default WorkPlaceDrawer;
